// Source: https://github.com/kaltura/kep-ve-management/blob/master/ve-management/apps/ve-client/src/app/app-ui/shared-ui/toasts-context.tsx
import { createContext, ReactNode, useContext } from "react";

export interface ToastOptions {
    message: ReactNode;
    severity: "error" | "warning" | "info" | "success";
}

export type ToastsContextValue = {
    showToast: (options: ToastOptions) => void;
};

export const toastsContextDefaultValue: ToastsContextValue = {
    showToast: () => {
        throw new Error("No toasts provider");
    },
};

/**
 * React context for pushing new toast notifications into the global notifications area.
 * See ToastsProvider.
 */
export const ToastsContext = createContext<ToastsContextValue>(toastsContextDefaultValue);

/**
 * React hook for pushing new toast notifications into the global notifications area.
 * See ToastsProvider.
 *
 * Usage:
 * ```
 * const { showToast } = useToastsContext();
 *
 * return <Button onClick={() => showToast({severity: "info", message: "Hi there!"});}>
 *     Notify me!
 * </Button>;
 * ```
 */
export const useToastsContext = (): ToastsContextValue => {
    return useContext(ToastsContext);
};
